import { render, staticRenderFns } from "./BonusTransaction.vue?vue&type=template&id=4f1eeb7e&scoped=true"
import script from "./BonusTransaction.vue?vue&type=script&lang=js"
export * from "./BonusTransaction.vue?vue&type=script&lang=js"
import style0 from "./BonusTransaction.vue?vue&type=style&index=0&id=4f1eeb7e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f1eeb7e",
  null
  
)

export default component.exports